import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Pagination } from '../../interfaces/common';

type Props = {
  pagination: Pagination;
  pageLink: string;
  pageQuery: (page?: number) => string;
};
const Paginate: FC<Props> = ({ pagination, pageLink, pageQuery }) => {
  const page = parseInt(pagination.page.toString());
  let startPage = page - 4;
  let endPage = page + 4;

  if (startPage <= 0) {
    endPage -= startPage - 1;
    startPage = 1;
  }

  if (endPage > pagination.last_page) {
    endPage = pagination.last_page;
  }

  const renderLink = () => {
    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li className={`page-item ${i === page ? 'active' : null}`} key={i}>
          <Link to={`${pageLink}${pageQuery(i)}`} className='page-link'>
            {i}
          </Link>
        </li>
      );
    }
    return pages;
  };

  return (
    <div className='text-center pt-10'>
      <ul className='pagination'>
        {startPage > 1 && (
          <li className='page-item previous'>
            <Link to={`${pageLink}${pageQuery(page - 1)}`} className='page-link'>
              <i className='previous'></i>
            </Link>
          </li>
        )}

        {renderLink()}

        {endPage < pagination.last_page && (
          <li className='page-item next'>
            <Link to={`${pageLink}${pageQuery(page + 1)}`} className='page-link'>
              <i className='next'></i>
            </Link>
          </li>
        )}
      </ul>
    </div>
  );
};

export default Paginate;
